module.exports = __webpack_public_path__ + "img/plent.713e7f63.svg";